import type { FC } from 'react';
import { LoadingContainer } from '..';
import { Pagination, PaginationWrapper } from '../Pagination';
import { ReviewItem } from './ReviewItem';
import * as Styled from './styled';
import type { EducatorReviewListProps } from './types';

export * from './types';

export const EducatorReviewList: FC<EducatorReviewListProps> = (props) => {
  const { pagination, amount, items, loading = false, ...rest } = props;

  if (loading) return <LoadingContainer />;

  return (
    <Styled.Wrapper {...rest} className="review-list-wrapper">
      <Styled.ItemContainer>
        {items.map((item, index) => (
          <ReviewItem {...item} key={index} {...rest} />
        ))}
      </Styled.ItemContainer>
      {pagination && (
        <PaginationWrapper>
          <Pagination {...pagination} marginPagesDisplayed={1} pageRangeDisplayed={2} />
        </PaginationWrapper>
      )}
    </Styled.Wrapper>
  );
};
